import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ProductsInCarouselAnalytics from '../../../functional-components/ProductsInCarouselAnalytics'
import ProductsInCarousel from './ProductsInCarousel'
import { TenantContext } from '../../../contexts/TenantContext'
import { getCarouselDefaultSettings } from './utils'
import ProductRecommendationsSkeleton from '../../ProductDetailPage/ProductRecommendations/Skeleton'
import './index.css'

const RESPONSIVE_1000_SLIDES_TO_SHOW = 3
const RESPONSIVE_1360_SLIDES_TO_SHOW = 4
const DEFAULT_SLIDES_TO_SHOW = 5

const getCarouselCustomSettings = (products, windowSize) => {
  const config = {}
  if (windowSize.width < 1000) {
    config.infinite = products.length > RESPONSIVE_1000_SLIDES_TO_SHOW
    return config
  }
  if (windowSize.width < 1360) {
    config.infinite = products.length > RESPONSIVE_1360_SLIDES_TO_SHOW
    return config
  }
  config.infinite = products.length > DEFAULT_SLIDES_TO_SHOW
  return config
}

class ProductSelection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productsToShow: 10,
      showButton: true,
    }
  }

  handleButtonClick = () => {
    const { productsToShow } = this.state
    this.setState({ productsToShow: productsToShow + 10, showButton: false })
  }

  render() {
    const { tenant } = this.context
    const { showButton } = this.state
    const {
      id,
      isMobile,
      productSelectionsAsCarousel,
      products,
      tab,
      index,
      customSettingsTopProducts,
      origin,
      windowSize,
    } = this.props
    return (
      <div id={id}>
        {products.length === 0 && (
          <div className="products-loader-container text-center" data-testid="product-selection-loader-test-id">
            <ProductRecommendationsSkeleton />
          </div>
        )}
        {products.length > 0 && (
          <Fragment>
            {productSelectionsAsCarousel && (
              <div className="mt-20">
                <ProductsInCarouselAnalytics
                  index={index}
                  tab={tab}
                  origin={origin}
                  className={`slider-${id}`}
                  products={products}
                  customSettingsTopProducts={customSettingsTopProducts}
                  settings={getCarouselDefaultSettings(getCarouselCustomSettings(products, windowSize))}
                >
                  <ProductsInCarousel isMobile={isMobile} tenant={tenant} />
                </ProductsInCarouselAnalytics>
              </div>
            )}
            {!productSelectionsAsCarousel && showButton && (
              <div
                role="presentation"
                className="show-more-products-button"
                onClick={this.handleButtonClick}
                onKeyPress={this.handleButtonClick}
              >
                Ver más productos
              </div>
            )}
          </Fragment>
        )}
      </div>
    )
  }
}
ProductSelection.defaultProps = {
  id: '',
  isMobile: true,
  productSelectionsAsCarousel: false,
  customSettingsTopProducts: null,
  origin: '',
  windowSize: {},
}

ProductSelection.propTypes = {
  products: PropTypes.array.isRequired,
  id: PropTypes.string,
  index: PropTypes.string,
  isMobile: PropTypes.bool,
  productSelectionsAsCarousel: PropTypes.bool,
  customSettingsTopProducts: PropTypes.any,
  tab: PropTypes.string,
  origin: PropTypes.string,
  windowSize: PropTypes.object,
}

ProductSelection.contextType = TenantContext

export default ProductSelection
